import React, { useContext, useEffect, useState } from "react";

import { AppContext } from "../../AppContext";
import {
  clearAuthOnlyCredentials,
  isAuthOnlySession,
  setAuthOnlyCredentials,
} from "../../utils/common";

import Login from "./Login";
import InviteForm from "../Onboarding/InviteForm/InviteForm";

export default function InviteCustomerFlow({ history }) {
  const context = useContext(AppContext);
  const [step, setStep] = useState(() => (
    isAuthOnlySession() ? "inviteForm" : "credentials"
  ));
  
  useEffect(() => () => clearAuthOnlyCredentials(), []);

  const handleCredentialsSuccess = (data, credentials) => {
    setAuthOnlyCredentials({
      firebase_id_token: data.firebase_id_token,
      firebase_refresh_token: data.firebase_refresh_token,
      expires_in: data.expires_in ? String(data.expires_in) : "",
      user_email: credentials.email,
    }, context);
    setStep("inviteForm");
  };

  if (step === "credentials") {
    return (
      <Login
        history={history}
        variant="invite"
        onCredentialsSuccess={handleCredentialsSuccess}
      />
    );
  }

  return (
    <InviteForm />
  );
}
